const AboutHero = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <div className="w-full h-64 border-4 border-yellow-500 rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/24703e3e1e32b36aa0dc7b30efb6d81e.jpg"
                  alt="Concrete pumping"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-full h-64 border-4 border-yellow-500 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=stone%20wall%20installation%20professional%20masonry%20work%20natural%20gray%20stone%20construction%20simple%20clean%20background&width=400&height=500&seq=about-2&orientation=portrait"
                  alt="Stone installation"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="space-y-4 pt-12">
              <div className="w-full h-64 border-4 border-yellow-500 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=residential%20foundation%20concrete%20pour%20construction%20workers%20team%20professional%20work%20simple%20clean%20background&width=400&height=500&seq=about-3&orientation=portrait"
                  alt="Foundation work"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-full h-64 border-4 border-yellow-500 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=commercial%20construction%20project%20concrete%20pumping%20large%20scale%20building%20work%20simple%20clean%20background&width=400&height=500&seq=about-4&orientation=portrait"
                  alt="Commercial project"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div>
            <div className="inline-block bg-yellow-500 text-black px-4 py-2 rounded-full text-sm font-bold mb-6">
              ABOUT US
            </div>

            <h1 className="text-5xl font-bold text-black mb-6 leading-tight">
              Building Excellence in Western North Carolina
            </h1>

            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              LG Concrete Pumping & Stone LLC is a trusted provider of concrete pumping and stone services in Otto, NC and surrounding areas. With years of experience, we deliver efficient, precise solutions for homes, businesses, and infrastructure projects.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Our team ensures every job is done right, minimizing issues and maximizing durability. We take pride in being a family-owned business dedicated to excellence and customer satisfaction.
            </p>

            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center border-2 border-yellow-500">
                  <i className="ri-medal-fill text-yellow-500 text-2xl"></i>
                </div>
                <span className="text-base font-semibold text-black">Veteran Owned Business</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-black text-2xl"></i>
                </div>
                <span className="text-base font-semibold text-black">Licensed & Insured</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-award-fill text-black text-2xl"></i>
                </div>
                <span className="text-base font-semibold text-black">Quality Guaranteed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;